import React from "react";
import _ from "lodash";
import CommentBox from "./common/CommentBox";
import CaseAgreement from "./common/CaseAgreement";
import AgreementDocCard from "./common/AgreementDocCard";
import useLifecycleStages from "../../../hooks/useLifecycleStages";

const PORTAL_NAME = "Cm";

const MediationState = ({
  currentState,
  isRespondent,
  ownerId,
  caseDetails,
  comments,
  setComments,
  partyList = [],
  isLocalTranscriptionServer,
}) => {
  const { getStageConfig } = useLifecycleStages(PORTAL_NAME);

  if (!currentState?.key) return null;

  const stageConfig = getStageConfig(currentState.key, caseDetails);

  const AgreementSection = () => (
    <>
      <div style={{ marginTop: 28 }}>
        <CaseAgreement
          title={`Final Award Summary for Case ID: ${caseDetails?.id}`}
          message={caseDetails?.negotiationSummary}
          summaryStatus={caseDetails?.summaryStatus === "completed"}
          isPaid={
            (currentState?.cta?.length ?? stageConfig.ctas?.length ?? 0) === 0
          }
        />
      </div>
      <div style={{ marginTop: 28 }}>
        <AgreementDocCard
          id={caseDetails?.id}
          status={caseDetails?.status}
          isRespondent={isRespondent}
          hasRating={caseDetails?.rating}
          hasAgreement={caseDetails?.hasAgreementDocument}
          type="Download"
        />
      </div>
    </>
  );

  return (
    <>
      <div style={{ marginTop: 28 }}>
        <CommentBox
          title={`${_.capitalize(caseDetails?.resolutionKind)} Process`}
          status={stageConfig.status}
          errorText={stageConfig.errorText}
          ownerId={ownerId}
          caseId={caseDetails?.id}
          comments={comments}
          setComments={setComments}
          disabled={!!stageConfig.commentDisabled}
          expand={!!stageConfig.commentExpanded}
          hideAddComment={!!stageConfig.hideAddComment}
          kind={
            caseDetails?.resolutionKind === "mediation"
              ? "Mediator"
              : "Arbitrator"
          }
          hasMediator={
            !!(
              caseDetails?.requestedMediators?.length &&
              caseDetails?.requestedMediators?.some((el) => el?.id)
            )
          }
          partyList={partyList}
          neutrals={caseDetails?.requestedMediators}
          respondentParties={caseDetails?.respondentParties}
          isLocalTranscriptionServer={isLocalTranscriptionServer}
          isRespondent={isRespondent}
          hasCaseManager={!_.isEmpty(caseDetails?.caseManager)}
        />
      </div>
      {!!stageConfig.showAgreement && <AgreementSection />}
    </>
  );
};

export default React.memo(MediationState);